import * as service from '../../service/CallApi';
import {AccountList} from "../../models/RequestModel";
import {initVerificationResponse, VerificationResponse} from "../../models/ResponseModel";

const types = {
    REG_PENDING_FETCH: "REG_PENDING_FETCH",
    REG_FETCH_SUCCESS: "REG_FETCH_SUCCESS",
    REG_FETCH_FAILURE: "REG_FETCH_FAILURE"
}

export const actions = {
    postRegAccounts: async (dispatch: any, request: AccountList) => {
        dispatch({type: types.REG_PENDING_FETCH})
        const json: VerificationResponse = await service.postRegisterAccount(request);
        if (json === undefined || json === null) {
            dispatch({type: types.REG_FETCH_FAILURE})
        } else {
            if (json.accessToken !== undefined) {
                dispatch({
                    type: types.REG_FETCH_SUCCESS,
                    payload: json
                })
            }

        }
    },
    initRegAccount: async (dispatch: any) => {
        dispatch({type: types.REG_PENDING_FETCH})
        const json: VerificationResponse = initVerificationResponse();
        if (json === undefined || json === null) {
            dispatch({type: types.REG_FETCH_FAILURE})
        } else {
            if (json.accessToken !== undefined) {
                dispatch({
                    type: types.REG_FETCH_SUCCESS,
                    payload: json
                })
            }

        }
    }
}

const initialState = {
    regAccounts: initVerificationResponse(),
    isFetching: false
};

export const regAccountReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.REG_FETCH_SUCCESS:
            return {
                ...state,
                regAccounts: action.payload,
                isFetching: false
            };
        case types.REG_FETCH_FAILURE:
            return {
                ...state,
                isFetching: false
            };
        case types.REG_PENDING_FETCH:
            return {
                ...state,
                isFetching: true
            }
        default:
            return state;
    }
}